export default __webpack_public_path__ + "static/media/treasure_hunt.57bfdf36.png";